import React, { useEffect, useState } from "react";
import { pullApiDetails } from "../../data/services/API";
import { KeyValueTable } from "../../components";
import _ from "lodash";

const TaskDetailsTab = ({ taskResult }) => {
  const [taskDetail, setTaskDetail] = useState(null);

  console.log("taskResult", taskResult);

  useEffect(() => {
    (async () => {
      try {
        let payload = new FormData();

        // switch (taskResult.taskType) {
        //   case "APPROVAL":
        //     payload.append(
        //       "data",
        //       JSON.stringify({
        //         requestId: Number(taskResult.inputData.requestId),
        //         requestApprovalStepsId:
        //           taskResult.outputData.response.body.data
        //             .requestApprovalStepsId,
        //       })
        //     );
        //     payload.append("dataApiName", "ApprovalHistory");

        //     break;
        //   case "USER_DATA":
        //     // const formData = new FormData();
        //     payload.append(
        //       "data",
        //       JSON.stringify({ userName: taskResult.inputData.userPsNo })
        //     );
        //     payload.append("dataApiName", "UserSearchList");

        //     break;
        //   case "REQUEST_DETAILS":
        //     payload.append(
        //       "data",
        //       JSON.stringify({
        //         requestId: taskResult.inputData.requestId,
        //       })
        //     );
        //     payload.append("dataApiName", "RequestSearchList");

        //     break;

        //   default:
        //     break;
        // }
        // console.log("taskResult", taskResult);
        if (taskResult.taskType === "APPROVAL") {
          payload.append(
            "data",
            JSON.stringify({
              requestId: Number(taskResult.inputData.requestId),
              requestApprovalStepsId:
                taskResult.outputData.response.body.data.requestApprovalStepsId,
            })
          );
          payload.append("dataApiName", "ApprovalHistory");
        } else if (taskResult.taskType === "USER_DATA") {
          payload.append(
            "data",
            JSON.stringify({ userName: taskResult.inputData.userPsNo })
          );
          payload.append("dataApiName", "UserSearchList");
        } 
        else 
        // if (taskResult.taskType === "REQUEST_DETAILS")
         {
          payload.append(
            "data",
            JSON.stringify({
              requestId: taskResult.inputData.requestId,
              limit:100,
              offset:0,
            })
          );
          // payload.append("dataApiName", "RequestSearchList");
          payload.append("dataApiName", "WflowHistoryDetails");
        } 
        
        const resp = await pullApiDetails(payload);
        if (resp.status === 200) {
          const data = _.get(resp.data, "data")[0];
          if (data) {
            const keyValPair = _.keys(data).map((key) => ({
              label: key,
              value: data[key],
            }));
            setTaskDetail(
              keyValPair.length ? keyValPair : [{ label: "", value: "No Data" }]
            );
          }
        }
      } catch (error) {
        if (error.response) {
          console.log(error.response);

          setTaskDetail([
            {
              label: "",
              // value: error?.response?.data?.message || "Something went wrong",
              value: "No Data Available",
            },
          ]);
        }
      }
    })();

    return () => {};
  }, [taskResult]);

  return <KeyValueTable data={taskDetail || []} />;
};

export default TaskDetailsTab;